module.exports = __webpack_public_path__ + "img/scandi-logo.89b1a702.png";